/**
 * @flow
 * @relayHash d0740c16d49a54f1529055979edcc4da
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ReportQueryResponse = {|
  +viewer: ?{| |};
  +report: ?{| |};
  +devices: ?{| |};
  +surveys: ?{| |};
  +reports: ?{| |};
|};
*/


/*
query ReportQuery(
  $reportId: ID!
) {
  viewer {
    ...ReportWrapper_viewer
  }
  report(id: $reportId) {
    ...ReportWrapper_report
    id
  }
  devices(showDeleted: true) {
    ...ReportWrapper_devices
  }
  surveys {
    ...ReportWrapper_surveys
  }
  reports {
    ...ReportWrapper_reports
  }
}

fragment ReportWrapper_viewer on Viewer {
  roles
  ...ReportHeader_viewer
  ...AdminReportGrid_viewer
  ...UserReportGrid_viewer
}

fragment ReportWrapper_report on Report {
  ...ReportHeader_report
  ...AdminReportGrid_report
  ...UserReportGrid_report
  ...CreateWidgetDialog_report
}

fragment ReportWrapper_devices on DeviceConnection {
  ...ReportHeader_devices
}

fragment ReportWrapper_surveys on SurveyConnection {
  ...ReportHeader_surveys
  ...AdminReportGrid_surveys
  ...UserReportGrid_surveys
  ...CreateWidgetDialog_surveys
}

fragment ReportWrapper_reports on ReportConnection {
  ...ReportHeader_reports
  ...UserReportGrid_reports
  ...AdminReportGrid_reports
}

fragment ReportHeader_reports on ReportConnection {
  ...CopyWidgetsDialog_reports
}

fragment UserReportGrid_reports on ReportConnection {
  ...WidgetTypeRouter_reports
}

fragment AdminReportGrid_reports on ReportConnection {
  ...WidgetTypeRouter_reports
}

fragment WidgetTypeRouter_reports on ReportConnection {
  ...withWidgetData_reports
}

fragment withWidgetData_reports on ReportConnection {
  ...WidgetMenu_reports
}

fragment WidgetMenu_reports on ReportConnection {
  ...CopyWidgetsDialog_reports
}

fragment CopyWidgetsDialog_reports on ReportConnection {
  edges {
    node {
      id
      name
    }
  }
}

fragment ReportHeader_surveys on SurveyConnection {
  edges {
    node {
      id
      name {
        text
        language
      }
    }
  }
  ...QuestionPicker_surveys
}

fragment AdminReportGrid_surveys on SurveyConnection {
  ...WidgetTypeRouter_surveys
}

fragment UserReportGrid_surveys on SurveyConnection {
  ...WidgetTypeRouter_surveys
  ...ExportCommentsWidget_surveys
}

fragment CreateWidgetDialog_surveys on SurveyConnection {
  ...WidgetForm_surveys
}

fragment WidgetForm_surveys on SurveyConnection {
  ...QuestionPicker_surveys
}

fragment QuestionPicker_surveys on SurveyConnection {
  edges {
    node {
      id
      name {
        text
        language
      }
      questions {
        edges {
          node {
            id
            mongoId
            type
            text {
              language
              text
            }
          }
        }
      }
    }
  }
}

fragment WidgetTypeRouter_surveys on SurveyConnection {
  ...withWidgetData_surveys
}

fragment ExportCommentsWidget_surveys on SurveyConnection {
  ...withWidgetData_surveys
}

fragment withWidgetData_surveys on SurveyConnection {
  ...WidgetMenu_surveys
}

fragment WidgetMenu_surveys on SurveyConnection {
  ...EditWidgetDialog_surveys
}

fragment EditWidgetDialog_surveys on SurveyConnection {
  ...WidgetForm_surveys
}

fragment ReportHeader_devices on DeviceConnection {
  ...ReportFilters_devices
  ...EditReportDialog_devices
}

fragment ReportFilters_devices on DeviceConnection {
  ...DevicePicker_relayDevices
  ...TagPicker_relayDevices
  edges {
    node {
      id
      tags
    }
  }
}

fragment EditReportDialog_devices on DeviceConnection {
  edges {
    node {
      id
      name
    }
  }
}

fragment DevicePicker_relayDevices on DeviceConnection {
  edges {
    node {
      id
      name
      location
    }
  }
}

fragment TagPicker_relayDevices on DeviceConnection {
  edges {
    node {
      id
      tags
    }
  }
}

fragment ReportHeader_report on Report {
  id
  mongoId
  name
  ...ReportFilters_report
  ...EditReportDialog_report
  ...CopyWidgetsDialog_report
}

fragment AdminReportGrid_report on Report {
  id
  layout {
    i
    x
    y
    w
    h
  }
  widgets {
    id
    type
    ...WidgetTypeRouter_widget
  }
  ...WidgetTypeRouter_report
}

fragment UserReportGrid_report on Report {
  id
  layout {
    i
    x
    y
    w
    h
  }
  widgets {
    id
    type
    ...WidgetTypeRouter_widget
    ...ExportCommentsWidget_widget
  }
  ...WidgetTypeRouter_report
  ...ExportCommentsWidget_report
}

fragment CreateWidgetDialog_report on Report {
  id
}

fragment WidgetTypeRouter_widget on Widget {
  id
  type
  ...withWidgetData_widget
}

fragment ExportCommentsWidget_widget on Widget {
  id
  type
  ...withWidgetData_widget
}

fragment WidgetTypeRouter_report on Report {
  ...withReportFilterProps_report
}

fragment ExportCommentsWidget_report on Report {
  ...withReportFilterProps_report
}

fragment withReportFilterProps_report on Report {
  id
  ...withWidgetData_report
}

fragment withWidgetData_report on Report {
  groupByLocation
  ...notifyPhantomWhenMounted_report
  ...CopyWidgetsDialog_report
}

fragment notifyPhantomWhenMounted_report on Report {
  id
  groupByLocation
}

fragment CopyWidgetsDialog_report on Report {
  id
  widgets {
    id
    name
    config {
      question {
        id
        text {
          text
          language
        }
      }
    }
  }
}

fragment withWidgetData_widget on Widget {
  id
  config {
    filterComments
    sliceByQuestion
    aggregateQuestions
    ignoreDateFilter
    showLastXMonths
    commentExtraColumns {
      title
      questionId
    }
  }
  ...WidgetMenu_widget
}

fragment WidgetMenu_widget on Widget {
  id
  ...EditWidgetDialog_widget
}

fragment EditWidgetDialog_widget on Widget {
  id
  name
  type
  config {
    filterComments
    sliceByQuestion
    aggregateQuestions
    subtitle
    ignoreDateFilter
    showLastXMonths
    hideHeader
    hideCommentTime
    staticYAxisScale
    commentExtraColumns {
      title
      questionId
    }
    question {
      mongoId
      id
    }
  }
}

fragment ReportFilters_report on Report {
  widgets {
    mongoId
    config {
      question {
        firstAnswerTime
        firstAnswerTimeByDevice {
          globalId
          deviceId
          localTime
          id
        }
        type
        id
      }
      useNumbers
    }
    id
  }
  filters {
    type
    locked
    ...OptionPicker_filter
  }
  ...DevicePicker_report
  ...DateRangePicker_report
  ...OptionPicker_report
  ...TagPicker_report
  devices {
    id
    tags
  }
  showTagsFilter
}

fragment EditReportDialog_report on Report {
  id
  name
  folder
  devices {
    id
    name
  }
  filters {
    type
    text {
      language
      text
    }
    question {
      mongoId
      text {
        language
        text
      }
      options {
        value
        text {
          language
          text
        }
      }
      id
    }
    locked
  }
  groupByLocation
  showTagsFilter
}

fragment OptionPicker_filter on ReportFilter {
  type
  text {
    language
    text
  }
  question {
    id
    mongoId
    type
    text {
      language
      text
    }
    options {
      value
      text {
        language
        text
      }
    }
  }
  locked
}

fragment DevicePicker_report on Report {
  id
  groupByLocation
  devices {
    id
    name
    location
  }
}

fragment DateRangePicker_report on Report {
  id
}

fragment OptionPicker_report on Report {
  id
}

fragment TagPicker_report on Report {
  id
  devices {
    id
    tags
  }
}

fragment ReportHeader_viewer on Viewer {
  roles
  accountName
  devices {
    id
    name
  }
  ...ReportFilters_viewer
}

fragment AdminReportGrid_viewer on Viewer {
  roles
}

fragment UserReportGrid_viewer on Viewer {
  roles
}

fragment ReportFilters_viewer on Viewer {
  roles
  ...DevicePicker_viewer
  ...TagPicker_viewer
  devices {
    id
    tags
  }
}

fragment DevicePicker_viewer on Viewer {
  devices {
    id
    name
    location
  }
}

fragment TagPicker_viewer on Viewer {
  devices {
    id
    tags
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "reportId",
        "type": "ID!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "viewer",
        "args": null,
        "concreteType": "Viewer",
        "name": "__viewer_viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ReportWrapper_viewer",
            "args": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "reportId",
            "type": "ID"
          }
        ],
        "concreteType": "Report",
        "name": "report",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ReportWrapper_report",
            "args": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "showDeleted",
            "value": true,
            "type": "Boolean"
          }
        ],
        "concreteType": "DeviceConnection",
        "name": "devices",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ReportWrapper_devices",
            "args": null
          }
        ],
        "storageKey": "devices{\"showDeleted\":true}"
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "SurveyConnection",
        "name": "surveys",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ReportWrapper_surveys",
            "args": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "ReportConnection",
        "name": "reports",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ReportWrapper_reports",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ReportQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "reportId",
        "type": "ID!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "ReportQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "roles",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "accountName",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Device",
            "name": "devices",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "location",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tags",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "args": null,
        "handle": "viewer",
        "name": "viewer",
        "key": "",
        "filters": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "reportId",
            "type": "ID"
          }
        ],
        "concreteType": "Report",
        "name": "report",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "mongoId",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Widget",
            "name": "widgets",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "mongoId",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "WidgetConfig",
                "name": "config",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Question",
                    "name": "question",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "firstAnswerTime",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "FirstAnswerTimeByDevice",
                        "name": "firstAnswerTimeByDevice",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "globalId",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "deviceId",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "localTime",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Translation",
                        "name": "text",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "text",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "language",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "useNumbers",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "type": "Widget",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetConfig",
                    "name": "config",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "filterComments",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "sliceByQuestion",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "aggregateQuestions",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "ignoreDateFilter",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "showLastXMonths",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "commentExtraColumn",
                        "name": "commentExtraColumns",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "questionId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "subtitle",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "hideHeader",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "hideCommentTime",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "staticYAxisScale",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Question",
                        "name": "question",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "mongoId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "ReportFilter",
            "name": "filters",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "locked",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Translation",
                "name": "text",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "language",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "text",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "name": "question",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "mongoId",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Translation",
                    "name": "text",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "language",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "text",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Option",
                    "name": "options",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "value",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Translation",
                        "name": "text",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "language",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "text",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "type": "ReportFilter",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Question",
                    "name": "question",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "type",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "groupByLocation",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Device",
            "name": "devices",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "location",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tags",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "showTagsFilter",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "folder",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "WidgetPosition",
            "name": "layout",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "i",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "x",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "y",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "w",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "h",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "showDeleted",
            "value": true,
            "type": "Boolean"
          }
        ],
        "concreteType": "DeviceConnection",
        "name": "devices",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "DeviceEdge",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Device",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "location",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "tags",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "devices{\"showDeleted\":true}"
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "SurveyConnection",
        "name": "surveys",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "SurveyEdge",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Survey",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Translation",
                    "name": "name",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "text",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "language",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "QuestionConnection",
                    "name": "questions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "QuestionEdge",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "Question",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "mongoId",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "type",
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "Translation",
                                "name": "text",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "language",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "text",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "ReportConnection",
        "name": "reports",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "ReportEdge",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Report",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query ReportQuery(\n  $reportId: ID!\n) {\n  viewer {\n    ...ReportWrapper_viewer\n  }\n  report(id: $reportId) {\n    ...ReportWrapper_report\n    id\n  }\n  devices(showDeleted: true) {\n    ...ReportWrapper_devices\n  }\n  surveys {\n    ...ReportWrapper_surveys\n  }\n  reports {\n    ...ReportWrapper_reports\n  }\n}\n\nfragment ReportWrapper_viewer on Viewer {\n  roles\n  ...ReportHeader_viewer\n  ...AdminReportGrid_viewer\n  ...UserReportGrid_viewer\n}\n\nfragment ReportWrapper_report on Report {\n  ...ReportHeader_report\n  ...AdminReportGrid_report\n  ...UserReportGrid_report\n  ...CreateWidgetDialog_report\n}\n\nfragment ReportWrapper_devices on DeviceConnection {\n  ...ReportHeader_devices\n}\n\nfragment ReportWrapper_surveys on SurveyConnection {\n  ...ReportHeader_surveys\n  ...AdminReportGrid_surveys\n  ...UserReportGrid_surveys\n  ...CreateWidgetDialog_surveys\n}\n\nfragment ReportWrapper_reports on ReportConnection {\n  ...ReportHeader_reports\n  ...UserReportGrid_reports\n  ...AdminReportGrid_reports\n}\n\nfragment ReportHeader_reports on ReportConnection {\n  ...CopyWidgetsDialog_reports\n}\n\nfragment UserReportGrid_reports on ReportConnection {\n  ...WidgetTypeRouter_reports\n}\n\nfragment AdminReportGrid_reports on ReportConnection {\n  ...WidgetTypeRouter_reports\n}\n\nfragment WidgetTypeRouter_reports on ReportConnection {\n  ...withWidgetData_reports\n}\n\nfragment withWidgetData_reports on ReportConnection {\n  ...WidgetMenu_reports\n}\n\nfragment WidgetMenu_reports on ReportConnection {\n  ...CopyWidgetsDialog_reports\n}\n\nfragment CopyWidgetsDialog_reports on ReportConnection {\n  edges {\n    node {\n      id\n      name\n    }\n  }\n}\n\nfragment ReportHeader_surveys on SurveyConnection {\n  edges {\n    node {\n      id\n      name {\n        text\n        language\n      }\n    }\n  }\n  ...QuestionPicker_surveys\n}\n\nfragment AdminReportGrid_surveys on SurveyConnection {\n  ...WidgetTypeRouter_surveys\n}\n\nfragment UserReportGrid_surveys on SurveyConnection {\n  ...WidgetTypeRouter_surveys\n  ...ExportCommentsWidget_surveys\n}\n\nfragment CreateWidgetDialog_surveys on SurveyConnection {\n  ...WidgetForm_surveys\n}\n\nfragment WidgetForm_surveys on SurveyConnection {\n  ...QuestionPicker_surveys\n}\n\nfragment QuestionPicker_surveys on SurveyConnection {\n  edges {\n    node {\n      id\n      name {\n        text\n        language\n      }\n      questions {\n        edges {\n          node {\n            id\n            mongoId\n            type\n            text {\n              language\n              text\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment WidgetTypeRouter_surveys on SurveyConnection {\n  ...withWidgetData_surveys\n}\n\nfragment ExportCommentsWidget_surveys on SurveyConnection {\n  ...withWidgetData_surveys\n}\n\nfragment withWidgetData_surveys on SurveyConnection {\n  ...WidgetMenu_surveys\n}\n\nfragment WidgetMenu_surveys on SurveyConnection {\n  ...EditWidgetDialog_surveys\n}\n\nfragment EditWidgetDialog_surveys on SurveyConnection {\n  ...WidgetForm_surveys\n}\n\nfragment ReportHeader_devices on DeviceConnection {\n  ...ReportFilters_devices\n  ...EditReportDialog_devices\n}\n\nfragment ReportFilters_devices on DeviceConnection {\n  ...DevicePicker_relayDevices\n  ...TagPicker_relayDevices\n  edges {\n    node {\n      id\n      tags\n    }\n  }\n}\n\nfragment EditReportDialog_devices on DeviceConnection {\n  edges {\n    node {\n      id\n      name\n    }\n  }\n}\n\nfragment DevicePicker_relayDevices on DeviceConnection {\n  edges {\n    node {\n      id\n      name\n      location\n    }\n  }\n}\n\nfragment TagPicker_relayDevices on DeviceConnection {\n  edges {\n    node {\n      id\n      tags\n    }\n  }\n}\n\nfragment ReportHeader_report on Report {\n  id\n  mongoId\n  name\n  ...ReportFilters_report\n  ...EditReportDialog_report\n  ...CopyWidgetsDialog_report\n}\n\nfragment AdminReportGrid_report on Report {\n  id\n  layout {\n    i\n    x\n    y\n    w\n    h\n  }\n  widgets {\n    id\n    type\n    ...WidgetTypeRouter_widget\n  }\n  ...WidgetTypeRouter_report\n}\n\nfragment UserReportGrid_report on Report {\n  id\n  layout {\n    i\n    x\n    y\n    w\n    h\n  }\n  widgets {\n    id\n    type\n    ...WidgetTypeRouter_widget\n    ...ExportCommentsWidget_widget\n  }\n  ...WidgetTypeRouter_report\n  ...ExportCommentsWidget_report\n}\n\nfragment CreateWidgetDialog_report on Report {\n  id\n}\n\nfragment WidgetTypeRouter_widget on Widget {\n  id\n  type\n  ...withWidgetData_widget\n}\n\nfragment ExportCommentsWidget_widget on Widget {\n  id\n  type\n  ...withWidgetData_widget\n}\n\nfragment WidgetTypeRouter_report on Report {\n  ...withReportFilterProps_report\n}\n\nfragment ExportCommentsWidget_report on Report {\n  ...withReportFilterProps_report\n}\n\nfragment withReportFilterProps_report on Report {\n  id\n  ...withWidgetData_report\n}\n\nfragment withWidgetData_report on Report {\n  groupByLocation\n  ...notifyPhantomWhenMounted_report\n  ...CopyWidgetsDialog_report\n}\n\nfragment notifyPhantomWhenMounted_report on Report {\n  id\n  groupByLocation\n}\n\nfragment CopyWidgetsDialog_report on Report {\n  id\n  widgets {\n    id\n    name\n    config {\n      question {\n        id\n        text {\n          text\n          language\n        }\n      }\n    }\n  }\n}\n\nfragment withWidgetData_widget on Widget {\n  id\n  config {\n    filterComments\n    sliceByQuestion\n    aggregateQuestions\n    ignoreDateFilter\n    showLastXMonths\n    commentExtraColumns {\n      title\n      questionId\n    }\n  }\n  ...WidgetMenu_widget\n}\n\nfragment WidgetMenu_widget on Widget {\n  id\n  ...EditWidgetDialog_widget\n}\n\nfragment EditWidgetDialog_widget on Widget {\n  id\n  name\n  type\n  config {\n    filterComments\n    sliceByQuestion\n    aggregateQuestions\n    subtitle\n    ignoreDateFilter\n    showLastXMonths\n    hideHeader\n    hideCommentTime\n    staticYAxisScale\n    commentExtraColumns {\n      title\n      questionId\n    }\n    question {\n      mongoId\n      id\n    }\n  }\n}\n\nfragment ReportFilters_report on Report {\n  widgets {\n    mongoId\n    config {\n      question {\n        firstAnswerTime\n        firstAnswerTimeByDevice {\n          globalId\n          deviceId\n          localTime\n          id\n        }\n        type\n        id\n      }\n      useNumbers\n    }\n    id\n  }\n  filters {\n    type\n    locked\n    ...OptionPicker_filter\n  }\n  ...DevicePicker_report\n  ...DateRangePicker_report\n  ...OptionPicker_report\n  ...TagPicker_report\n  devices {\n    id\n    tags\n  }\n  showTagsFilter\n}\n\nfragment EditReportDialog_report on Report {\n  id\n  name\n  folder\n  devices {\n    id\n    name\n  }\n  filters {\n    type\n    text {\n      language\n      text\n    }\n    question {\n      mongoId\n      text {\n        language\n        text\n      }\n      options {\n        value\n        text {\n          language\n          text\n        }\n      }\n      id\n    }\n    locked\n  }\n  groupByLocation\n  showTagsFilter\n}\n\nfragment OptionPicker_filter on ReportFilter {\n  type\n  text {\n    language\n    text\n  }\n  question {\n    id\n    mongoId\n    type\n    text {\n      language\n      text\n    }\n    options {\n      value\n      text {\n        language\n        text\n      }\n    }\n  }\n  locked\n}\n\nfragment DevicePicker_report on Report {\n  id\n  groupByLocation\n  devices {\n    id\n    name\n    location\n  }\n}\n\nfragment DateRangePicker_report on Report {\n  id\n}\n\nfragment OptionPicker_report on Report {\n  id\n}\n\nfragment TagPicker_report on Report {\n  id\n  devices {\n    id\n    tags\n  }\n}\n\nfragment ReportHeader_viewer on Viewer {\n  roles\n  accountName\n  devices {\n    id\n    name\n  }\n  ...ReportFilters_viewer\n}\n\nfragment AdminReportGrid_viewer on Viewer {\n  roles\n}\n\nfragment UserReportGrid_viewer on Viewer {\n  roles\n}\n\nfragment ReportFilters_viewer on Viewer {\n  roles\n  ...DevicePicker_viewer\n  ...TagPicker_viewer\n  devices {\n    id\n    tags\n  }\n}\n\nfragment DevicePicker_viewer on Viewer {\n  devices {\n    id\n    name\n    location\n  }\n}\n\nfragment TagPicker_viewer on Viewer {\n  devices {\n    id\n    tags\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/scenes/Report/__generated__/ReportQuery.graphql.js